export enum TimePeriodEnum {
  HOURLY = "1H",
  DAILY = "1D",
  WEEKLY = "1W",
  MONTHLY = "1M",
  THREE_MONTHS = "3M",
  SIX_MONTHS = "6M",
  YEARLY = "1Y",
}
